const ignoreLegacyIvwScript = ({ivw_st_desktop, ivw_st_mobil}) => {
  const ignore = [
    'augsallg',
    'mobaugsb',
    'rponl',
    'mobrpo',
    'ippenmed',
    'mobippen',
    'bkzonl',
    'mainrhei',
    'mobrmm',
    'nwnews',
    'mobnwnew',
  ];
  const ignoreIvw = ignore.includes(ivw_st_desktop) || ignore.includes(ivw_st_mobil);
  return ignoreIvw;
};

export {ignoreLegacyIvwScript};
